import React, { useEffect, useState } from 'react'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { Box, Button, IconButton, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import Loader from '../../../Components/Loader'

export default function SubHeadGroupTest(props) {
    const [states, setStates] = useState({
        isAddSubHead: props?.isAddSubHead || false,
        subHeadName: '',
        subHeadPrint: '',
        subHeadList: [],
        subHeadEditID: null,
        EditGrpId: props?.groupID || null,
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: '',
        PrintOrderLength: props?.testlength || 0,
        deleted_ids: [],
        isLoader: false,
    })

    useEffect(() => {
        if (props.groupID) {
            getGrpSubHeadlist(props.groupID)
        }
    }, [props]);

    const getGrpSubHeadlist = (id) => {
        try {
            setStates(prev => ({ ...prev, isLoader: true }))
            RestAPIService.getAll(`${Serviceurls.LAB_SUB_HEADING_POST}?grp_id=${id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setStates(prev => ({
                            ...prev,
                            subHeadList: response.data.data || [],
                            isLoader: false
                        }))
                    }
                })
                .catch((error) => {
                    setStates(prev => ({ ...prev, isLoader: false }))
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            setStates(prev => ({ ...prev, isLoader: false }))
            errorMessage(e.message)
        }
    }

    const editSubName = (item) => {
        setStates(prev => ({ ...prev, subHeadName: item.sub_heading, subHeadPrint: item.print_order, subHeadEditID: item.id || item._tempId }))
    }

    const errorMessage = (msg) => {
        setStates(prev => ({ ...prev, isErrorMsg: true, isErrorMsgText: msg }))
    }
    const successMessage = (msg) => {
        setStates(prev => ({ ...prev, successMsg: true, successMsgText: msg }))
    }

    const handleAddOrUpdate = () => {
        if (!states.subHeadName) {
            return errorMessage('Please enter Sub-Heading Name')
        }
        if (!states.subHeadPrint) {
            return errorMessage('Please enter Print Order')
        }

        setStates(prev => {
            // EDIT case
            if (prev.subHeadEditID) {
                const updatedList = prev.subHeadList?.map(item =>
                    item.id === prev.subHeadEditID || item._tempId === prev.subHeadEditID
                        ? {
                            ...item,
                            sub_heading: prev.subHeadName.trim(),
                            print_order: prev.subHeadPrint
                        }
                        : item
                );

                return {
                    ...prev,
                    subHeadList: updatedList,
                    subHeadName: '',
                    subHeadPrint: '',
                    subHeadEditID: null
                };
            }

            // ADD case
            const newItem = {
                _tempId: Date.now(), // unique frontend id
                sub_heading: prev.subHeadName.trim(),
                print_order: prev.subHeadPrint
            };

            return {
                ...prev,
                subHeadList: [...prev.subHeadList, newItem],
                subHeadName: '',
                subHeadPrint: ''
            };
        });
    };

    const deleteSubHead = (item) => {
        setStates(prev => {
            const updatedList = prev.subHeadList?.filter(
                i => (i.id || i._tempId) !== (item.id || item._tempId)
            );

            return {
                ...prev,
                subHeadList: updatedList,
                deleted_ids: item.id
                    ? [...prev.deleted_ids, item.id]
                    : prev.deleted_ids
            };
        });
    };

    const handleFinalSubmit = () => {
        try {
            setStates(prev => ({ ...prev, isLoader: true }))
            let payload = {
                "grp_id": states?.EditGrpId,
                "subheading_data": states.subHeadList?.map(({ _tempId, ...rest }) => rest),
                "deleted_ids": states.deleted_ids
            }
            RestAPIService.create(payload, `${Serviceurls.LAB_SUB_HEADING_POST}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response?.data?.message)
                        getGrpSubHeadlist(states?.EditGrpId)
                        setStates(prev => ({ ...prev, isLoader: false }))
                    }
                })
                .catch((error) => {
                    setStates(prev => ({ ...prev, isLoader: false }))
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            setStates(prev => ({ ...prev, isLoader: false }))
            errorMessage(e.message)
        }
    };

    const msgClose = () => {
        setStates(prev => ({
            ...prev,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        }))
    }

    return (
        <Box>
            <Modal open={states.isAddSubHead} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box component={'div'} sx={{ width: '40vw', height: '65vh', backgroundColor: 'white', borderRadius: '.2vw' }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '1vw', borderBottom: '1px solid #E3E2E2' }}>
                        <Typography fontSize={'1vw'} fontWeight={'bold'}>{`Add Sub-Heading (Test Count: ${states?.PrintOrderLength})`}</Typography>
                        <IconButton size='small' onClick={() => { setStates(prev => ({ ...prev, subHeadName: '', subHeadPrint: '' })); props.sendOpen(false) }}><img style={{ width: '1vw', height: '1vw' }} src={ImagePaths.LabCloseButton.default} alt='close' /></IconButton>
                    </Box>
                    <Box component={'div'} sx={{ height: '50vh' }}>
                        <Box padding={'.5vw'} width={'38vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <TextField
                                size="small"
                                name="subHeadName"
                                label="Sub-Heading Name"
                                sx={{ width: "18vw" }}
                                value={states?.subHeadName}
                                inputProps={{ maxLength: 100 }}
                                onChange={(e) => setStates((prev) => ({ ...prev, subHeadName: e.target.value }))}
                            />
                            <TextField
                                size="small"
                                name="subHeadPrint"
                                label="Print Order"
                                sx={{ width: "10vw" }}
                                value={states?.subHeadPrint}
                                onChange={(e) => {
                                    let number = CommonValidation.numberOnly(e.target.value);
                                    if ((number && +e.target.value <= 999) || e.target.value === "") {
                                        setStates(prev => ({ ...prev, subHeadPrint: e.target.value }));
                                    }
                                }}
                            />
                            <Tooltip title="add" placement='top'>
                                <IconButton onClick={handleAddOrUpdate}>
                                    <Box component={'img'} src={ImagePaths.AddIcon.default} alt='add' height={'2vw'} width={'2vw'} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Clear" placement='top'>
                                <IconButton onClick={() => setStates(prev => ({ ...prev, subHeadName: '', subHeadPrint: '', subHeadEditID: null, }))}>
                                    <Box component={'img'} src={ImagePaths.ClearIcon.default} alt='add' height={'2vw'} width={'2vw'} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Box padding={'.5vw'} sx={{ height: '40vh' }}>
                            <Paper elevation={1}>
                                <TableContainer sx={{ maxHeight: '38vh', overflowY: 'scroll'}} component={'div'}>
                                    <Table sx={{ width: '100%', tableLayout: 'fixed'}} stickyHeader size='small'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{width: '60%'}}  id='eMed_config_TableRow1'> Sub Heading</TableCell>
                                                <TableCell sx={{width: '30%'}} id='eMed_config_TableRow'>Print Order</TableCell>
                                                <TableCell sx={{width: '10%'}} id='eMed_config_TableRow' align='center'>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {states.subHeadList?.length > 0 ? states.subHeadList?.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{width: '60%'}}>
                                                        {item.sub_heading.length > 35 ?
                                                            <Tooltip title={item.sub_heading} placement='top' arrow>
                                                                <Typography variant='body2'>{item.sub_heading.slice(0, 35) + '...'}</Typography>
                                                            </Tooltip> :
                                                            <Typography variant='body2'>{item.sub_heading || '-'}</Typography>}
                                                    </TableCell>
                                                    <TableCell sx={{width: '30%'}}>{item?.print_order || '-'}</TableCell>
                                                    <TableCell sx={{width: '10%'}} align='center'>
                                                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                                            <Tooltip title='Edit' placement='top' arrow>
                                                                <Box component={'img'} style={{ cursor: 'pointer' }} src={ImagePaths.LabEditButton.default} height={'1.5vw'} width={'1.5vw'} mr={'1vw'} onClick={() => editSubName(item)} />
                                                            </Tooltip>
                                                            <Tooltip title='Delete' placement='top' arrow>
                                                                <Box component={'img'} style={{ cursor: 'pointer' }} src={ImagePaths.LabDeleteButton.default} height={'1.5vw'} width={'1.5vw'} onClick={() => deleteSubHead(item)} />
                                                            </Tooltip>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            )) :
                                                <TableRow>
                                                    <TableCell colSpan={3} align='center'>No Records Found</TableCell>
                                                </TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Box>
                    </Box>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginTop: '1vw', marginRight: '.5vw' }}>
                        <Button variant='outlined' size='small' sx={{ textTransform: 'capitalize', marginRight: '1vw', width: '10vw' }} onClick={() => { setStates(prev => ({ ...prev, subHeadName: '', subHeadPrint: '' })); props.sendOpen(false) }}>Cancel</Button>
                        <Button variant='contained' size='small' sx={{ textTransform: 'capitalize', width: '10vw' }} onClick={handleFinalSubmit}>Add</Button>
                    </Box>
                </Box>
            </Modal>
            {states?.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={states.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {states.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={states.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            <Loader loaderOpen={states?.isLoader} />
        </Box>
    )
}
